//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { CustomFieldValueInputItem } from './CustomFieldValueInputItem';
import { CustomFieldType } from './Enums';

export class CustomFieldDateValueInputItem extends CustomFieldValueInputItem {
    Date: string | null = null;
    override readonly FieldType: CustomFieldType = CustomFieldType.CheckedList;

    constructor(initializer?: Partial<Omit<CustomFieldDateValueInputItem, "FieldType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomFieldDateValueInputItem";
}
